import React, {PropTypes} from 'react';
import {Col, Row} from 'react-bootstrap/lib/';
import FormInput from './forminput.react';

export const stringToFaqs = (value, faqs) => {
  const v = value || '';
  const answers = v.split('|');

  return faqs
    .toJS()
    .map((question, index) => {
      const answer = answers.length > index ? answers[index] : '';
      return {question, answer, index};
    });
};

export const faqsToString = (faqs) => {
  return faqs
    .map((faq) => faq.answer)
    .join('|');
};

export default class FaqInput extends FormInput {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    questions: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }

  onFieldChanged(event) {
    const {name, value, questions, actions: {updateFieldList}} = this.props;
    const {target: {value: fieldValue, dataset: {fieldIndex}}} = event;
    const faqs = stringToFaqs(value, questions);

    faqs[fieldIndex].answer = fieldValue;
    const stringValue = faqsToString(faqs);
    updateFieldList({name, value: stringValue});
  }

  render() {
    const {title, value, questions} = this.props;
    const faqs = stringToFaqs(value, questions);
    // const fields = stringToFields(value, title);
    return (
      <Col xs={12}>
        <h3>{title}</h3>
        <Row>
          <Col className="group-note" xs={12}>
            Your answers to the questions below will help show your personality and give couples a sense of what it's like working with you and your business - beyond a general description of services.  Answer as many as you like, and have fun with your personalised responses!
          </Col>
        </Row>
        <div className="form-group">
          {faqs.map(({question, answer, index}) => {
            return (
              <div className="form-group" key={index}>
                <h4>{question}</h4>
                <textarea
                  rows="2"
                  className="form-control"
                  type="text"
                  placeholder="Enter your answer"
                  data-field-index={index}
                  value={answer}
                  onChange={::this.onFieldChanged}
                />
              </div>
            );
          })}
        </div>
      </Col>
    );
  }
}
